import 'console-polyfill'
import 'custom-event-polyfill'
import './core/Sentry'
// nette
import './nette/NetteAutosubmit'
import './nette/NetteValidationMessages'

import elementClosestPolyfill from 'element-closest'

import { loadComponents } from './core/componentUtils'
import TouchMouseInputResolver from './meta/TouchMouseInputResolver'
import Nette from './nette/NetteForms'
import NajaService from './services/Naja'
import ScrollService from './services/Scroll'
import scrollToElement from './services/Viewport/scrollToElement'
import { runFocusSkip } from './utils/focus'

elementClosestPolyfill(window)

window.Nette = Nette
Nette.validators['AppFormsFrontCustomValidators_name'] = (elem, args,val) => {
    const pattern = new RegExp(/^[\p{L} \-]{1,50}$/,'u');
    return pattern.test(val)
}
Nette.initOnLoad()

NajaService.initialize()

new TouchMouseInputResolver()

ScrollService.useNative()
setScrollPosition()

loadComponents()

runFocusSkip()

function setScrollPosition(x = null, y = null) {
    const id = window.location.hash.replace('#', '')
    const anchor = id ? document.getElementById(id) : null

    if (id && anchor) {
        scrollToElement(anchor)
    } else if (x !== null && y !== null) {
        ScrollService.setPosition(x, y)
    } else {
        //default chovani prohlizece
    }
}
